import { FormControl } from '@software-platforms/design-system-components';

export interface SubscriptionForm {
  license: FormControl;
  orgSubscriptionId: FormControl;
  companyName: FormControl;
  allowedTenants: FormControl;
}
